import { useState } from 'react'
import classes from './MessageLine.module.css'
import useBotsService from '../../../services/bot/botService';
import { useBotConfig } from '../../../context/BotConfigContext';
import { ReactComponent as SendArrow } from '../../../assets/SendArrow.svg';

function MessageLine() {
    
    const [value, setValue] = useState(null)
    const botService = useBotsService()
    const config = useBotConfig()

    const sendMessage = () => {
        if (value == null || value == "") return
        botService.sendMessage(value)
        setValue("")
    }

    const onChange = (e) => {
        setValue(e.target.value)
    }

    const onKeyDown = event => {
        if (event.key == "Enter") {
            event.preventDefault();
            sendMessage()
        }
    }

    const disabled = botService.getCurrentSession() == null || botService.isPendingResponse()

    return (
        <div className={classes.MessageLine}>
            <button disabled={disabled} className={disabled ? classes.SendButtonDisabled : classes.SendButton} onClick={sendMessage}>
                <SendArrow style={{position: "relative", left: "2px"}}/>
            </button>
            <input 
                type="text"
                id="textInput"
                className={classes.TextInput}
                onChange={onChange} 
                value={value} 
                placeholder={config?.typeHereText}
                onKeyDown={onKeyDown}
            />
                
        </div>
    );
}

export default MessageLine;
